export default [
    {
        path: '/forms',
        name: 'listForms',
        component: () => import('../views/registers/dynamic/forms/List.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/forms/templates',
        name: 'listFormsTemplates',
        component: () => import('../views/registers/dynamic/forms/TemplatesList.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/forms/fieldDetails',
        name: 'formFieldDetails',
        component: () => import('../views/administration/dynamicRegisters/FieldsDetails.vue'),
        props: () => ({ fieldDetailsType: 'forms' }),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/forms/activate',
        name: 'formActivation',
        component: () => import('../views/registers/dynamic/forms/FormActivation.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/forms/create',
        name: 'createForm',
        component: () => import('../views/editors/FormsEditor.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'create' }] },
        props: (route) => (
        { relatedId: Number(route.query.relatedId), returnUrl: route.query.returnUrl })
    },
    {
        path: '/forms/edit',
        name: 'editForm',
        component: () => import('../views/editors/FormsEditor.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'update' }] },
        props: (route) => ({ id: Number(route.query.id), returnUrl: route.query.returnUrl })
    },
    {
        path: '/forms/copy',
        name: 'copyForm',
        component: () => import('../views/editors/FormsEditor.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'create' }] },
        props: (route) => ({ id: Number(route.query.id), isCopy: true, eventId: Number(route.query.eventId), returnUrl: route.query.returnUrl })
    },
    {
        path: '/forms/details',
        name: 'formDetails',
        component: () => import('../views/editors/FormsEditor.vue'),
        props: (route) => ({ id: Number(route.query.id), readonly: true, returnUrl: route.query.returnUrl })
    },
    {
        path: '/forms/active',
        name: 'listActiveForms',
        component: () => import('../views/registers/dynamic/forms/ListActive.vue'),
        meta: { claims: [{ name: 'formSurvey', crud: 'read' }] }
    },
    {
        path: '/forms/my',
        name: 'listMyForms',
        component: () => import('../views/registers/dynamic/forms/ListCompleted.vue'),
        props: (route) => ({ listAll: false }),
        meta: { claims: [{ name: 'formSurvey', crud: 'read' }] }
    },
    {
        path: '/forms/all',
        name: 'listAllCompletedForms',
        component: () => import('../views/registers/dynamic/forms/ListCompleted.vue'),
        meta: { claims: [{ name: 'formSurvey', crud: 'create' }, { name: 'formSurvey', crud: 'update' }, { name: 'formSurvey', crud: 'delete' }] },
        props: (route) => ({ listAll: true })
    },
    {
        path: '/forms/complete',
        name: 'completeForm',
        component: () => import('../views/registers/dynamic/forms/Form.vue'),
        props: (route) => ({ id: route.query.id, name: route.query.name, isCompleting: true, returnUrl: route.query.returnUrl, returnOnSave: true }),
        meta: { claims: [{ name: 'formSurveyEntity', crud: 'create' }] }
    },
    {
        path: '/forms/entryEdit',
        name: 'editFormEntry',
        component: () => import('../views/registers/dynamic/forms/Form.vue'),
        props: (route) => ({ id: route.query.id, entryId: route.query.entryId, name: route.query.name, returnUrl: route.query.returnUrl, returnOnSave: true }),
        meta: { claims: [{ name: 'formSurveyEntity', crud: 'create' }] }
    },
    {
        path: '/forms/entryDetails',
        name: 'detailsFormEntry',
        component: () => import('../views/registers/dynamic/forms/Form.vue'),
        props: (route) => ({ id: route.query.id, entryId: route.query.entryId, name: route.query.name, returnUrl: route.query.returnUrl, details: true })
    },
    {
        path: '/forms/records/:id',
        name: 'formToEntityRecords',
        component: () => import('../views/registers/dynamic/forms/FormRecords.vue'),
        props: (route) => ({ id: Number(route.params.id) })
    },
    {
        path: '/forms/summaryReport',
        name: '/forms/summaryReport',
        component: () => import('../views/registers/dynamic/forms/SummaryReport.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
]
